import { ContentCopy, Download } from "@mui/icons-material";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { downloadFile } from "../../../utils/filesUtils";
import snackbarUtils from "../../../utils/snackbarUtils";
import { StyledXMLNews } from "../../styled/xml";

const XmlViewerDialog = ({ open, onClose, xml, loading, title = "Visualizar XML", filename = "wsmlart.xml" }) => {
    const handleCopy = async () => {
        if (!xml) {
            snackbarUtils.error("No hay XML para copiar.");
            return;
        }

        try {
            await navigator.clipboard.writeText(xml);
            snackbarUtils.success("XML copiado al portapapeles.");
        } catch (error) {
            snackbarUtils.error("No se pudo copiar el XML.");
        }
    };

    const handleDownload = () => {
        if (!xml) {
            snackbarUtils.error("No hay XML para descargar.");
            return;
        }

        downloadFile(xml, filename);
        snackbarUtils.success("XML descargado correctamente.");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box display="flex" justifyContent="center" padding={2}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StyledXMLNews.XmlVisualizer>
                        {xml || "No hay datos XML para mostrar."}
                    </StyledXMLNews.XmlVisualizer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCopy} color="primary" variant="outlined" startIcon={<ContentCopy />}>
                    Copiar
                </Button>
                <Button onClick={handleDownload} color="primary" variant="outlined" startIcon={<Download />}>
                    Descargar
                </Button>
                <Button onClick={onClose} color="primary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default XmlViewerDialog;
